import { call, put, takeLatest } from 'redux-saga/effects';

import {
    FETCH_ATTENDANCE_REQUEST,
    FETCH_ATTENDANCE_SUCCESS,
    FETCH_ATTENDANCE_FAILURE
} from './actionTypes';

import {
    fetchAttendanceRequest,
    fetchAttendanceSuccess,
    fetchAttendanceFailure
} from './actions';

import axiosInstance from 'pages/Utility/axiosInstance';
import { showSuccess } from 'helpers/notification_helper';

const fetchAttendanceAPI = async (params) => {
  const response = await axiosInstance.get("V1/attendance/full-attendance", { params });
  return response.data;
};

//sagas

//fetch chapters

function* fetchAttendanceSaga(action) {
  try {
    const response = yield call(fetchAttendanceAPI, action.payload);
  yield put(fetchAttendanceSuccess(response));

  } catch (error) {
    yield put(fetchAttendanceFailure(error.message));
  }
}

export default function* attendanceSaga(){
    yield takeLatest(FETCH_ATTENDANCE_REQUEST, fetchAttendanceSaga);
}